import { render, staticRenderFns } from "./ManufactureProductPropsList.vue?vue&type=template&id=48c0b437&scoped=true&"
import script from "./ManufactureProductPropsList.vue?vue&type=script&lang=js&"
export * from "./ManufactureProductPropsList.vue?vue&type=script&lang=js&"
import style0 from "./ManufactureProductPropsList.vue?vue&type=style&index=0&id=48c0b437&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c0b437",
  null
  
)

export default component.exports